export const SETTINGS_PAGE_TAB_OPTIONS = Object.freeze({
  General: 'general',
  Members: 'members',
  Entities: 'entities',
  Invoices: 'invoices',
});

export type SettingsPageTabOption =
  (typeof SETTINGS_PAGE_TAB_OPTIONS)[keyof typeof SETTINGS_PAGE_TAB_OPTIONS];
